import { PhoneNumberInput } from '@adc/parallax-component-library';

import type { CLMPhoneInputProps } from './types';

export const CLMPhoneInput = ({
  label,
  placeholder,
  ariaLabel,
  ...rest
}: CLMPhoneInputProps) => {
  return (
    <PhoneNumberInput
      aria-label={ariaLabel ?? label ?? 'Phone Number (Optional)'}
      label={label ?? 'Phone number (Optional)'}
      placeholder={placeholder ?? 'Phone'}
      inputMode="tel"
      autoCapitalize="none"
      autoCorrect={false}
      {...rest}
    />
  );
};
